import initialState from './initialState';
import {
  FETCH_REQUESTED_STIPS,
  RECEIVE_REQUESTED_STIPS,
  SET_FILES_TO_BE_UPLOADED,
  SET_STIP_FILE_TAG,
  SET_STIP_FILE_DESCRIPTION,
  SET_STIP_FILE_OWNER,
  SET_STIP_FILE_EXPIRATION,
  RECEIVE_SUBMISSION_OWNERS
} from '../actions/actionTypes';

export default function requestedStipsInfo(state = initialState.requestedStipsInfo, action) {
  let newState = { ...state };
  switch (action.type) {
    case FETCH_REQUESTED_STIPS:
      return action;
    case RECEIVE_REQUESTED_STIPS:
      return { ...state, requestedStips: action.requestedStips };
    case SET_FILES_TO_BE_UPLOADED:
      return { ...state, requestedStipsFormInfo: { files: action.files } };
    case SET_STIP_FILE_TAG:
      newState.requestedStipsFormInfo.files.find((file) => {
        return file.preview === action.data.filePreview;
      }).tag = action.data.tagValue;
      return newState;
    case SET_STIP_FILE_DESCRIPTION:
      newState.requestedStipsFormInfo.files.find((file) => {
        return file.preview === action.data.filePreview;
      }).description = action.data.description;
      return newState;
    case SET_STIP_FILE_OWNER:
      newState.requestedStipsFormInfo.files.find((file) => {
        return file.preview === action.data.filePreview;
      }).owner_uuid = action.data.ownerUuid;
      return newState;
    case SET_STIP_FILE_EXPIRATION:
      newState.requestedStipsFormInfo.files.find((file) => {
        return file.preview === action.data.filePreview;
      }).expires_on = action.data.expiresOn;
      return newState;
    case RECEIVE_SUBMISSION_OWNERS:
      return { ...state, owners: action.owners, ownersLoaded: true };
    default:
      return state;
  }
}
